const ADD = 'ADD'
const REMOVE = 'REMOVE'

const initialState = {
    toasters: []
}

const toastReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case ADD:
            if (state.toasters.length === 0) {
                const newToaster = []
                newToaster[payload.position] = state.toasters[payload.position] || []
                newToaster[payload.position].push(payload)

                return {
                    ...state,
                    toasters: newToaster
                }
            }

            return {
                ...state,
                toasters: state.toasters.map(toaster => {
                    toaster[payload.position] = state.toasters[payload.position] || []
                    toaster[payload.position].push(payload)
                    return toaster
                })
            }
        case REMOVE:
            return {
                ...state,
                toasters: []
            }
        default:
            return state
    }
}

export default toastReducer
